import React from 'react'
import { connect } from 'react-redux'
import { Button } from 'semantic-ui-react'

import { getRFPUrl } from './helper';
import { 
  MainBodyContent,
} from 'components'

import { ProcurementContainer, ProcurementBody } from '../styled'

const RfpLandingPage = (props) => {

  const { user } = props

  React.useEffect(()=>{
    if(user.username){
      window.open(getRFPUrl(user))
    }
  },[user.username])

  return (
    <MainBodyContent headerTitle="Request for Proposal">
      <ProcurementContainer>
        <ProcurementBody>
          {user.username?
          <Button size='massive' color='#c5b7a1' style={{width:'50%', alignSelf:'center'}}
            onClick={()=>window.open(getRFPUrl(user))}
          >
            Go To Request for Proposal System
          </Button>:null}
        </ProcurementBody>
      </ProcurementContainer>
    </MainBodyContent>
  )
}

const mapStateToProps = state => ({
  user: state.authen.user
})

const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(RfpLandingPage)
